<template>
  <b-card-code
    title="ویرایش مشخصات مشتری"
  >
    <b-form @submit.prevent>
      <b-row>

        <!-- name -->
        <b-col cols="6">
          <b-form-group
            label="نام"
            label-for="vi-name"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="UserIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-name"
                v-model="customer.name"
                placeholder=""
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <!-- پروتکل -->
        <b-col cols="6">
          <b-form-group
            label="نام خانوادگی"
            label-for="vi-family"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="UserIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-name"
                v-model="customer.family"
                placeholder=""
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <!-- reset and submit -->
        <b-col cols="12">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1"
            @click="submitForm()"
          >
            Submit
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="reset"
            class="mr-1"
            variant="outline-secondary"
          >
            Reset
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="button"
            class="mr-1"
            variant="outline-primary"
            @click.prevent="onCancel"
          >
            Cancel
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {
  BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BInputGroup, BInputGroupPrepend,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
// eslint-disable-next-line import/extensions
import ToastificationContent from '@core/components/toastification/ToastificationContent'

import CustomerService from '@/services/customer.service'
import router from '@/router'
import Customer from '@/models/customer'

export default {
  components: {
    BCardCode,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      customer: new Customer('', '', '', '', '', ''),
      options: [],
    }
  },
  created() {
    if ('id' in this.$route.params) {
      this.getContactById()
    }
  },
  methods: {
    getContactById() {
      CustomerService.getById({ id: this.$route.params.id }).then(
        res => {
          if (res.status === 'success') {
            this.customer = res.result.data
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'register error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    async submitForm() {
      CustomerService.edit(this.customer).then(
        res => {
          if (res.status === 'success') {
            router.push({ name: 'admin-manager-list' })
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'register error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    onCancel() {
      this.show = false
      this.$router.push({ name: 'admin-manager-list' })
    },
  },
}
</script>
